/**
 * This file is an alternative of `product-model.js` on Shopify.
 * It overloads the default model-viewer with the `webgi-viewer` from the iJewel3D SDK(https://ijewel3d.com).
 * This file must be included in the theme manually, and referenced in the pages where product-model.js was used.
 * Check the docs for more information and updates. - https://developer.ijewel3d.com/integrations/shopify
 *
 * File version - 15-08-2025
 */

// Settings for the iJewel3D SDK, this includes the webgi package version, environment maps etc.
// This can be set externally in the metafields or in the page where the product model is used, if not, the default settings will be used.
window.iJewelSDKSettings = {
  webgi_version: "0.16.1",
  miniviewer_version: "0.4.0",
  scene_settings: "",
  environment_map: "",
  license_key: "",
  loading: {
    //loadingTextHeader: "Loading iJewel 3D Experience",
    showFileNames: false,
    backgroundOpacity: 0.5,
    background: "#ffffff",
    textColor: "#222222",
    logoImage: "",
  },
  autoplay: true,
  ...(window.iJewelSDKSettings || {}),
};

if (!document.getElementById("miniviewer-script")) {
  const viewerScript = document.createElement("script");
  viewerScript.setAttribute("id", "miniviewer-script");
  viewerScript.setAttribute(
    "src",
    window.iJewelSDKSettings.miniviewer_version.includes("/")
      ? window.iJewelSDKSettings.miniviewer_version // assume URL
      : "https://releases.ijewel3d.com/libs/mini-viewer/" +
          (window.iJewelSDKSettings.miniviewer_version || "0.4.0") +
          "/bundle.iife.js"
  );
  document.head.appendChild(viewerScript);

  const webgiScript = document.createElement("script");
  webgiScript.setAttribute("id", "ijewel-script");
  webgiScript.setAttribute(
    "src",
    window.iJewelSDKSettings.webgi_version.includes("/")
      ? window.iJewelSDKSettings.webgi_version // assume URL
      : "https://dist.pixotronics.com/webgi/runtime/viewer-" +
          (window.iJewelSDKSettings.webgi_version || "0.16.1") +
          ".js"
  );
  document.head.appendChild(webgiScript);

  const project = {
    modelUrl: "https://demo-assets.pixotronics.com/pixo/gltf/jewlr1.glb",
    basePath: "drive",
    icon360:
      "https://cdn.shopify.com/s/files/1/0893/3847/8926/files/icon-360.svg?v=1751301970",
    logo: "https://cdn.shopify.com/s/files/1/0893/3847/8926/files/diamonet-loading-logo.png?v=1751302772",
    sceneConfig: {
      /* scene configuration */
    },
    materialConfig: {
      /* material configuration */
    },
    configuratorConfig: [
      /* configurator configuration */
    ],
  };

  const viewerOptions = {
    showCard: false,
    showSwitchNode: false,
    splitMaterialTabs: true,
    useIjewelLogo: false,
    hideQuality: true,
    logoScale: 1,
    showLogo: false,
    hideQuality: true,
    hideRotateCamera: true,
    transparentBg: false,
    runRotateCamera: true,
    showConfigurator: false,
    showShare: false,
    embedLogo: {
      icon: "https://cdn.shopify.com/s/files/1/0893/3847/8926/files/icon-360.svg?v=1751301970",
      logo: null,
      url: null,
      logoWidth: 120,
      iconAmimation: "flip",
    },
  };

  // LoadViewer(viewerScript, webgiScript);
  viewerScript.onload = async () => {
    if (!customElements.get("model-viewer")) {
      customElements.define(
        "model-viewer",
        class ModelViewerWebGi extends HTMLElement {
          onVariantChangeUnsubscriber = undefined;

          activeMetalColor = undefined;
          activeGemColor = undefined;
          activeCarat = undefined;
          activeFeingoldbarren = undefined;
          activeDiamantschliff = undefined;

          switchNodeVariations = undefined;
          materialVariations = undefined;

          metalColurs = {
            "585 Weißgold": "Whitegold",
            "750 Weißgold": "Whitegold",
            "585 Gelbgold": "Gold",
            "750 Gelbgold": "Gold",
            "750 Roségold": "Rosegold",
            "585 Roségold": "Rosegold",
            "950 Platin": "Whitegold",
          };

          gemColours = {
            Weiß: "White",
            Gelb: "Yellow",
            Blau: "Blue",
            Grün: "Green",
            Pink: "Pink",
            Peach: "Peach",
          };

          diamondCutShorthands = {
            "Brillant Cut": "RB",
            "Oval Cut": "OV",
            "Pear Shape": "PE",
          };

          constructor() {
            super();
            const container = document.createElement("div");
            this.container = container;
            this.container.style.width = "100%";
            this.container.style.height = "100%";
            this.container.setAttribute("id", "miniviewer-container");
            this.appendChild(container);
            this.modelLoaded = false;
            this.initialize();
          }

          connectedCallback() {
            this.onVariantChangeUnsubscriber = subscribe(
              PUB_SUB_EVENTS.optionValueSelectionChange,
              this.handleOptionValueChange.bind(this)
            );
          }

          doOnLoad(fn) {
            if (this.modelLoaded) fn();
            this.onLoad = fn;
          }

          async initialize() {
            project.modelUrl = this.getAttribute("src");
            let modelId;
            let baseName = "drive";
            if (project.modelUrl.includes("?id=")) {
              modelId = new URL(project.modelUrl).searchParams.get("id");
            } else if (
              project.modelUrl.includes(".ijewel3d.com/drive/files/")
            ) {
              modelId = project.modelUrl.split("/")[5];
            }
            this.viewer;
            this.viewer2;
            if (!modelId) {
              this.viewer = new ijewelViewer.Viewer(
                this.container,
                project,
                viewerOptions
              );
            } else {
              this.viewer = ijewelViewer.loadModelById(
                modelId,
                baseName ?? "drive",
                this.container,
                viewerOptions
              );
            }

            window.addEventListener("ijewel-viewer-ready", async (ev) => {
              this.viewer2 = ev.detail.viewer;
              const miniviewerContainer = document.getElementById(
                "miniviewer-container"
              );
              if (miniviewerContainer.firstElementChild) {
                miniviewerContainer.firstElementChild.style.setProperty(
                  "display",
                  "block",
                  "important"
                );
              }

              this.activeMetalColor =
                [...document.querySelectorAll("variant-selects fieldset")]
                  .find(
                    (fs) =>
                      fs.querySelector("legend")?.textContent.trim() ===
                      "Metalllegierung"
                  )
                  ?.querySelector('input[type="radio"]:checked')?.value || null;

              this.activeGemColor =
                [...document.querySelectorAll("variant-selects fieldset")]
                  .find((fs) => {
                    const legendText = fs
                      .querySelector("legend")
                      ?.textContent.trim();
                    return (
                      legendText === "Hauptstein" ||
                      legendText === "Diamantfarbe"
                    );
                  })
                  ?.querySelector('input[type="radio"]:checked')?.value || null;

              this.activeCarat =
                [...document.querySelectorAll("variant-selects fieldset")]
                  .find(
                    (fs) =>
                      fs.querySelector("legend")?.textContent.trim() === "Carat"
                  )
                  ?.querySelector('input[type="radio"]:checked')?.value || null;

              this.activeFeingoldbarren =
                [...document.querySelectorAll("variant-selects fieldset")]
                  .find(
                    (fs) =>
                      fs.querySelector("legend")?.textContent.trim() ===
                      "Feingoldbarren"
                  )
                  ?.querySelector('input[type="radio"]:checked')?.value || null;

              this.activeDiamantschliff =
                [...document.querySelectorAll("fieldset")]
                  .find(
                    (fs) =>
                      fs.querySelector("legend")?.textContent.trim() ===
                      "Diamantschliff"
                  )
                  ?.querySelector('input[type="radio"]:checked')?.value || null;

              this.viewer2.renderer.displayCanvasScaling = Math.min(
                window.devicePixelRatio,
                1.5
              );
            });

            window.addEventListener("ijewel-scene-ready", async (ev) => {
              const switchNodePlugin =
                this.viewer2.getPluginByType("SwitchNodePlugin");
              if (switchNodePlugin) {
                this.switchNodeVariations = getSwitchNodeConfigurators(
                  this.viewer2
                );

                function getSwitchNodeConfigurators(viewer) {
                  if (!viewer) return [];
                  const configuratorsArray = [];
                  const switchNodePlugin =
                    viewer.getPluginByType("SwitchNodePlugin");
                  switchNodePlugin.variations.forEach((variation) => {
                    const name = variation.name;
                    const title = variation.name;

                    const nodeChildren =
                      viewer.scene.getObjectByName(name)?.children || [];

                    const getOptions = () => {
                      return nodeChildren.map((child) => ({
                        name: child.name,
                        icon: child.userData.__icon,
                      }));
                    };

                    const isSelected = (option) => {
                      return variation.selected === option.name;
                    };

                    const applyOption = async (option) => {
                      const plugin = viewer.getPluginByType("SwitchNodePlugin");
                      if (plugin?.selectNode) {
                        plugin.selectNode(variation, option.name);
                      } else {
                        variation.selected = option.name;
                        viewer.setDirty({ sceneUpdate: true, frameFade: true });
                      }
                    };

                    const configurator = {
                      name,
                      title,
                      getOptions: getOptions,
                      isSelected,
                      applyOption,
                      type: "switchNode",
                    };

                    configuratorsArray.push(configurator);
                  });

                  return configuratorsArray;
                }
              }

              const materialConfiguratorPlugin = this.viewer2.getPluginByType(
                "MaterialConfiguratorPlugin"
              );
              if (materialConfiguratorPlugin) {
                this.materialVariations = getMaterialConfigurators(
                  this.viewer2
                );

                materialConfiguratorPlugin.addEventListener(
                  "deserialize",
                  () => {
                    this.materialVariations = getMaterialConfigurators(
                      this.viewer2
                    );
                  }
                );
                materialConfiguratorPlugin.addEventListener("refreshUi", () => {
                  this.materialVariations = getMaterialConfigurators(
                    this.viewer2
                  );
                });

                function materialExists(viewer, variation) {
                  if (!viewer) return false;
                  let found = false;
                  viewer.scene.traverse((object) => {
                    if (object.isMesh) {
                      const n = object.material?.name;
                      try {
                        const re = new RegExp(variation.uuid);
                        if (n && re.test(n)) {
                          found = true;
                        }
                      } catch {
                        if (n === variation.uuid) {
                          found = true;
                        }
                      }
                    }
                  });
                  return found;
                }

                function getMaterialConfigurators(viewer) {
                  if (!viewer) return [];
                  const materialConfiguratorPlugin = viewer.getPluginByType(
                    "MaterialConfiguratorPlugin"
                  );
                  if (!materialConfiguratorPlugin) return [];
                  const configuratorsArray = [];
                  materialConfiguratorPlugin.variations.forEach(
                    (variation, i) => {
                      const name = variation.uuid || variation.title;
                      const title = variation.title || variation.uuid;

                      if (!materialExists(viewer, variation)) return;

                      const getOptions = () => {
                        return materialConfiguratorPlugin.options[i] || [];
                      };

                      const isSelected = (option) => {
                        return variation.selectedIndex === option.index;
                      };

                      const applyOption = async (option) => {
                        await materialConfiguratorPlugin.applyVariation(
                          variation,
                          option.uuid
                        );
                      };

                      const handleDelete = (option) => {
                        materialConfiguratorPlugin.removeVariation({
                          uuid: option?.name,
                        });
                      };

                      const addCurrentMaterial = async () => {
                        const picking = viewer.getPlugin("PickingPlugin");
                        const mesh = picking?.getSelectedObject();
                        if (!mesh || !mesh.material) return;
                        const mat = mesh.material.clone?.();
                        // mat.uuid = variation.uuid;
                        materialConfiguratorPlugin.addVariation(
                          mat,
                          name,
                          false
                        );
                      };

                      const configurator = {
                        name,
                        title,
                        getOptions: getOptions,
                        isSelected,
                        applyOption,
                        handleDelete,
                        addCurrentMaterial,
                        type: "materialConfiguratorPlugin",
                      };

                      configuratorsArray.push(configurator);
                    }
                  );

                  return configuratorsArray;
                }
              }
              if (this.activeCarat) this.applyCaratSize(this.activeCarat);
              if (this.activeFeingoldbarren)
                this.applyGoldVariant(this.activeFeingoldbarren);
              if (this.activeDiamantschliff)
                this.applyDiamondCutVariant(this.activeDiamantschliff);
              if (this.activeGemColor) {
                setTimeout(() => {
                  this.applyGemColour(this.activeGemColor);
                }, 500);
              }
              if (this.activeMetalColor) {
                setTimeout(() => {
                  this.applyMetalColour(this.activeMetalColor);
                }, 500);
              }
            });

            //for diamond type change
            document.addEventListener("change", (event) => {
              if (event.target.matches('fieldset input[name^="sync["]')) {
                let fieldset = event.target.closest("fieldset");
                let legend = fieldset?.querySelector("legend");

                if (
                  legend &&
                  legend.textContent.trim().toLowerCase() === "diamantschliff"
                ) {
                  this.activeDiamantschliff = event.target.value;
                  this.applyDiamondCutVariant(event.target.value);
                }
              }
            });
          }

          disconnectedCallback() {
            this.onVariantChangeUnsubscriber();
          }

          async handleOptionValueChange({
            data: { event, target, selectedOptionValues },
          }) {
            if (event.target.name.startsWith("Metalllegierung")) {
              this.activeMetalColor = event.target.value;
              this.applyMetalColour(this.activeMetalColor);
            } else if (
              event.target.name.startsWith("Diamantfarbe") ||
              event.target.name.startsWith("Hauptstein")
            ) {
              this.activeGemColor = event.target.value;
              this.applyGemColour(this.activeGemColor);
            } else if (event.target.name.startsWith("Carat")) {
              this.activeCarat = event.target.value;
              this.applyCaratSize(event.target.value);
            } else if (event.target.name.startsWith("Feingoldbarren")) {
              this.activeFeingoldbarren = event.target.value;
              this.applyGoldVariant(event.target.value);
            } else if (event.target.name.startsWith("Diamantschliff")) {
              this.activeDiamantschliff = event.target.value;
              this.applyDiamondCutVariant(event.target.value);
            } else {
              console.log("Unknown variant selected");
            }
          }

          async applyDiamondCutVariant(selectedVariant) {
            if (!this.switchNodeVariations) return;
            const diamondCutVariant = this.switchNodeVariations.find((ff) =>
              ff.name.startsWith("dia")
            );
            if (!diamondCutVariant) return;
            const allDiamondCutVariant = diamondCutVariant.getOptions();
            const paddedValue = String(this.activeCarat * 100).padStart(3, "0");
            const finalVariant = `${
              this.diamondCutShorthands[selectedVariant] ?? "RB"
            }-${paddedValue}`;
            const selectedDiamondCutVariant = allDiamondCutVariant.find((vv) =>
              vv.name.endsWith(finalVariant)
            );
            if (selectedDiamondCutVariant)
              await diamondCutVariant.applyOption(selectedDiamondCutVariant);
          }

          async applyCaratSize(selectedVariant) {
            if (!this.switchNodeVariations) return;
            const caratVariant = this.switchNodeVariations.find((ff) =>
              ff.name.startsWith("dia")
            );
            if (!caratVariant) return;
            const allCaratVariant = caratVariant.getOptions();
            const paddedValue = String(selectedVariant * 100).padStart(3, "0");
            const finalVariant = `${
              this.diamondCutShorthands[this.activeDiamantschliff] ?? "RB"
            }-${paddedValue}`;
            const selectedCaratVariant = allCaratVariant.find((vv) =>
              vv.name.endsWith(finalVariant)
            );
            if (selectedCaratVariant)
              await caratVariant.applyOption(selectedCaratVariant);
          }

          async applyGoldVariant(selectedVariant) {
            if (!this.switchNodeVariations) return;
            const goldVariant = this.switchNodeVariations.find((ff) =>
              ff.name.startsWith("Gold")
            );
            const allGoldVariant = goldVariant.getOptions();
            const selectedGoldVariant = allGoldVariant.find((vv) => {
              return selectedVariant === "ohne"
                ? vv.name === "No_Gold"
                : vv.name.endsWith(selectedVariant);
            });
            if (selectedGoldVariant)
              await goldVariant.applyOption(selectedGoldVariant);
          }

          async applyMetalColour(selectedVariant) {
            const metalVariant = this.materialVariations.find((ff) =>
              ff.name.startsWith("Metal")
            );
            if (!metalVariant) return;
            const allMetalVariant = metalVariant.getOptions();
            const finalVariant =
              this.metalColurs[this.activeMetalColor] ?? "Whitegold";
            const selectedMetalVariant = allMetalVariant.find((vv) =>
              vv.name.endsWith(finalVariant)
            );
            if (selectedMetalVariant)
              await metalVariant.applyOption(selectedMetalVariant);
          }

          async applyGemColour(selectedVariant) {
            const gemVariant = this.materialVariations.find((ff) =>
              ff.name.startsWith("Gem 01")
            );
            if (!gemVariant) return;
            const allGemVariant = gemVariant.getOptions();
            const finalVariant =
              this.gemColours[this.activeGemColor] ?? "White";
            const selectedGemVariant = allGemVariant.find((vv) =>
              vv.name.endsWith(finalVariant)
            );
            if (selectedGemVariant)
              await gemVariant.applyOption(selectedGemVariant);
          }
        }
      );
    }
  };

  if (!customElements.get("product-model")) {
    customElements.define(
      "product-model2",
      class ProductModel extends DeferredMedia2 {
        constructor() {
          super();

          const template = this.querySelector("template");
          if (template) {
            const viewer = template.content.querySelector("model-viewer");
            if (viewer) {
              delete viewer.dataset.shopifyFeature;
            } else {
              console.warn("No model-viewer found in template");
            }
          } else {
            console.warn("No template found in product-model2");
          }
        }

        async loadContent(focus = true) {
          super.loadContent(focus);
          const modelViewer = this.querySelector("model-viewer");
          if (modelViewer) {
            console.log("Model viewer loaded in ProductModel2");
            // Additional model viewer setup can go here
          }
        }
        setupModelViewerUI(errors) {
          if (errors) {
            console.error("Errors setting up model viewer UI:", errors);
            return;
          }
        }
      }
    );
  }
}

// Set a dummy ProductModel in the window, just in case
window.ProductModel = {
  loadShopifyXR() {},

  setupShopifyXR(errors) {
    if (errors) return;
  },
};
